import { render } from "./Gridding.vue?vue&type=template&id=1c37fa81"
import script from "./Gridding.vue?vue&type=script&lang=js"
export * from "./Gridding.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wesratcliff/Desktop/Projects/reporting/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__